import { Component } from 'react'
import axios from 'axios'

const XHR = axios.create()
const prefix = process.env.NODE_ENV === 'production' ? '//api.thetis.org.uk' : '//localhost:3000'

class Request extends Component {
  static get(url) {
    return XHR(`${prefix || ''}${url}`, {
      method: 'get',
      withCredentials: true
    })
      .then(res => {
        return res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  static post(url, data) {
    return XHR(`${prefix || ''}${url}`, {
      method: 'post',
      data: data,
      withCredentials: true
    })
      .then(res => {
        return res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  static put(url, data) {
    return XHR(`${prefix || ''}${url}`, {
      method: 'put',
      data: data,
      withCredentials: true
    })
      .then(res => {
        return res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  static patch(url, data) {
    return XHR(`${prefix || ''}${url}`, {
      method: 'patch',
      data: data,
      withCredentials: true
    })
      .then(res => {
        return res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  static delete(url, data) {
    return XHR(`${prefix || ''}${url}`, {
      method: 'delete',
      data: data,
      withCredentials: true
    })
      .then(res => {
        return res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}

export default Request


// WEBPACK FOOTER //
// ./src/services/Request/Request.js